export default __webpack_public_path__ + "static/media/1.26431622.jpg";